import { ToasterComponent } from 'src/app/components/common/toaster/toaster.component';
import { ITranslateService } from 'src/data/services/common/translate/translate-service';
import { LanguageKey } from 'src/main/translate/language-key/language-key';
import { CustomErrorTitle } from 'src/models/common/error/custom-error-title/custom-error-title';

type PublicErrorToaster = Pick<ToasterComponent, 'error'>;
type PublicErrorTranslateService = Pick<
  ITranslateService,
  'isLanguageKey' | 'translateKey'
>;

interface ShowPublicErrorToastsParams {
  publicErrors?: unknown[] | null;
  toaster: PublicErrorToaster;
  translateService: PublicErrorTranslateService;
  defaultMessageKey?: LanguageKey;
}

export function showPublicErrorToasts({
  publicErrors,
  toaster,
  translateService,
  defaultMessageKey = LanguageKey.AN_ERROR_HAS_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST,
}: ShowPublicErrorToastsParams): void {
  if (publicErrors?.length) {
    publicErrors.forEach((msg) => {
      toaster.error(
        CustomErrorTitle.OOPS_SOMETHING_WENT_WRONG,
        translateService.isLanguageKey(msg)
          ? translateService.translateKey(msg)
          : String(msg),
      );
    });

    return;
  }

  toaster.error(
    CustomErrorTitle.EMPTY,
    translateService.translateKey(defaultMessageKey),
  );
}
